module.exports = __webpack_public_path__ + "img/2_x6.868aa93c.png";